import type { ActionType, TriggerType } from "@/types";

export interface WorkflowFormData {
  name: string;
  description: string;
  enabled: boolean;
  triggerType: TriggerType;
  // Trigger filters
  triggerAccountId: string;
  cronExpression: string;
  emailFrom: string;
  emailSubjectContains: string;
  emailBodyContains: string;
  attachmentIgnoreList: string; // One filename pattern per line
  // Actions
  actions: Array<{
    type: ActionType;
    password?: string;
    accountId?: string;
    statementType?: string;
    month?: string;
    triggerExtraction?: boolean;
    autoUpload?: boolean;
    renameFile?: boolean;
    ignorePagesFromEnd?: number;
    aiModel?: string;
    url?: string;
  }>;
}

export const TRIGGER_TYPES: { value: TriggerType; label: string }[] = [
  { value: "email_received", label: "Email Received" },
  { value: "scheduled", label: "Scheduled (Cron)" },
  { value: "manual", label: "Manual" },
];

export const ACTION_TYPES: {
  value: ActionType;
  label: string;
  description: string;
}[] = [
  {
    value: "unlock_pdf",
    label: "Unlock PDF",
    description: "Unlock password-protected PDF",
  },
  {
    value: "webhook",
    label: "Call Webhook",
    description: "Call external webhook URL",
  },
  {
    value: "add_as_statement",
    label: "Add as Statement",
    description: "Save PDF as statement for an account",
  },
];
